import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { TranslateService } from '@ngx-translate/core/';
import { Component, OnInit } from '@angular/core';
import { SalesNetworkService } from '../../../services/sales-network/sales-network.service';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { SalesNetwork } from '../../../models/sales-network.model';

@Component({
  selector: 'app-sales-network',
  templateUrl: './sales-network.component.html',
  styleUrls: ['./sales-network.component.css']
})
export class SalesNetworkComponent implements OnInit {

  customFilter = KontableComponent.CustomFilter;
  selectedSalesNetwork: SalesNetwork = null;
  salesNetworks: any[];
  listStates: Array<{value: string, label: string}>
  newDataAvailable = false;
  show = {
    dialog: false
  }
  statusFilter: any;
  common = {}
  modalTitle = '';
  labels = {};

  constructor(
    private srvSalesNetwork: SalesNetworkService,
    private srvDataTable: DataTableService,
    private translate: TranslateService
  ) { }

  ngOnInit() {

    this.refresh();

    this.translate.get([
      'common.all',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'salesNetworkList.add_title',
      'salesNetworkList.edit_title'
    ]).subscribe(t => {
      this.listStates = [];
      this.listStates.push({label: t['common.all'], value: ''});
      this.listStates.push({label: t['common.status_notDeleted'], value: '0'});
      this.listStates.push({label: t['common.status_onlyDeleted'], value: '1'});

      this.labels['add_title'] = t['salesNetworkList.add_title'];
      this.labels['edit_title'] = t['salesNetworkList.edit_title'];
    });

  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.selectedSalesNetwork = data == null ? new SalesNetwork() : data;
    this.common['sales_network_title'] = (data == null) ? this.common['add_title'] : this.common['edit_title']
    this.show.dialog = true;
    // this.srvSalesNetwork.salesNetworkEditing = data == null ? new SalesNetwork() : data;
  }

  delete (record): void {
    this.srvSalesNetwork.delete(record).subscribe(res => {
      this.refresh();
    });

  }

  salesNetworkAdded($event): void {
    this.srvSalesNetwork.post($event).subscribe(() => {
      this.srvDataTable.get('dt_salesNetwork').showDetail = false;
      this.refresh();
    });
  }

  salesNetworkUpdated($event): void {
    this.srvSalesNetwork.put($event).subscribe(res => {
      this.srvDataTable.get('dt_salesNetwork').showDetail = false;
      this.refresh();
      }
    )
  }

  refresh() {
    this.show.dialog = false;
    this.salesNetworks = [];
    this.srvSalesNetwork.getAll().subscribe(res => {
      for (let i = 0; i < res.length; i++) {
        this.salesNetworks.push(res[i]);
        /*
        if(res[i].flg_state != '1'){
          this.salesNetworks.push(res[i]);
        }
        */
      }
      this.newDataAvailable = true;
    })
  }

  onDialogHide () {
    this.show.dialog = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/sales-network/sales-network.component.ts